import React from "react";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import _ from "underscore";

import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";
import {getActiveCollections} from "../../actionCreators/boostCommerceAC";
import ProductVariation from "../../PDP/Columns/ProductVariation";
import Image from "react-bootstrap/Image";
import config from "../../../config";
import Slider from "react-slick";
import {
    countNonEmptyCollections,
    getImageSize,
    removeEmptyKeysFromObject,
    carouselSettings,
    getCookie
} from "../../common/utils";

class CuratedCollections extends React.Component {
    componentDidMount() {
        this.props.getActiveCollections();
    }

    render() {
        const slider_settings = {
            className: "products-carousel__cards rebag-carousel__cards",
            dotsClass: "slick-dots--custom",
        }
        const sliderSettings = carouselSettings(slider_settings);

        const collections_prefix = "bc-filter-";
        const {curated_collections} = this.props;
        const curated_collections_with_items = removeEmptyKeysFromObject(curated_collections);
        const curated_collections_keys = _.shuffle(Object.keys(curated_collections_with_items));
        const collections_with_products = countNonEmptyCollections(curated_collections);
        const is_b2b = getCookie('is_b2b');
        const is_wholesale_active = getCookie("is_wholesale_active");

        if(curated_collections_keys.length <= 0){
            return (
                <div/>
            )
        }

        return (
            <div className="rebag-carousel curated-collections-carousel">
                <Row>
                    <Col>
                        <h2 className="rebag-carousel__title">Curated Collections</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Tabs
                            defaultActiveKey={curated_collections_keys[0]}
                            id="curated-collections"
                            className={`rebag-carousel__tab-container ${(collections_with_products < 3) ? "rebag-carousel__tab-container--center" : ""}`}
                        >
                        {_.map(curated_collections_with_items, (curated_collection, curated_collection_filter) => {
                            if (_.isEmpty(curated_collection.products)) {
                                return null;
                            }
                            const collection_name = curated_collection_filter.replace(collections_prefix, '');
                            const shopify_url = `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_t_collections=${curated_collection_filter}&pf_st_availability_hidden=true`;
                            const tab_title = <span>
                                <span className="rebag-carousel__tab--img-container">
                                    <Image
                                        alt={collection_name}
                                        className="rebag-carousel__tab--img"
                                        src={getImageSize(curated_collection.products[0].images[Object.keys(curated_collection.products[0].images)[0]], 96)}
                                        width="48"
                                        height="48"
                                    />
                                </span>
                                <div
                                    className="rebag-carousel__tab--title"
                                >
                                    {collection_name}
                                </div>
                                <div className="rebag-carousel__tab--border"/>
                            </span>;
                            return (
                                <Tab
                                    key={curated_collection_filter}
                                    eventKey={curated_collection_filter}
                                    title={tab_title}
                                    unmountOnExit={true}
                                    tabClassName="rebag-carousel__tab"
                                >
                                    <div className="products-carousel__cards-container">
                                        <Container className="position-relative">
                                            <Slider {...sliderSettings}>
                                                {_.map(curated_collection.products, (product) => {
                                                    return (
                                                        <ProductVariation
                                                            key={product.id}
                                                            product_variation={product}
                                                            is_b2b={is_b2b}
                                                            is_wholesale_active={is_wholesale_active}
                                                        />
                                                    )
                                                })}
                                                {curated_collection.total_products > 14 &&
                                                <div className="products-carousel__card products-carousel__card--more-items">
                                                    <a
                                                        href={shopify_url}
                                                        className="products-carousel__card-link-container"
                                                    >
                                                        <span className="icon-shopping-bag saved-search__more-items-icon"/>
                                                        <div className="saved-search__more-items-title">
                                                            More Matches Available
                                                        </div>
                                                        <div className="saved-search__more-items-link">
                                                            View All
                                                        </div>
                                                    </a>
                                                </div>
                                                }
                                            </Slider>
                                            <a
                                                href={shopify_url}
                                                className='rebag-carousel__see-all-cta'
                                            >
                                                See All <i/>
                                            </a>
                                        </Container>
                                    </div>
                                </Tab>
                            )
                        })}
                        </Tabs>
                    </Col>
                </Row>
            </div>
        )
    }
}


const mapStateToProps = function (state) {
    const { curated_collections } = state.appReducer;
    return { curated_collections };
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getActiveCollections,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CuratedCollections);